import { connect } from 'react-redux'

import {
  selectReplyDraft,
  selectNewEmailIsSendable,
  doRemoveDraftRecipients,
  doUpdateReplyDraft,
  doUpdateReplyDraftDelayed,
  doUpdateAndSendNewEmail,
} from 'ducks/drafts'

import Composer from './view'

const select = state => ({
  draft: selectReplyDraft(state),
  isDraftSendable: selectNewEmailIsSendable(state),
  ticketId: 'new',
})

// bindActionCreators not playing well with our curried action creators
const perform = dispatch => ({
  removeDraftRecipients: (...args) =>
    dispatch(doRemoveDraftRecipients(...args)),
  updateDraft: (ticketId, prop, val) =>
    dispatch(doUpdateReplyDraft(ticketId, prop, val)),
  updateDraftDelayed: (ticketId, prop, val) =>
    dispatch(doUpdateReplyDraftDelayed(ticketId, prop, val)),
  updateAndSendDraft: (ticketId, prop, val) =>
    dispatch(doUpdateAndSendNewEmail(ticketId, prop, val)),
})

// Parent props take precedence (e.g. isDraftSendable )
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
})

export default connect(select, perform, mergeProps)(Composer)
